module.exports = __webpack_public_path__ + "static/media/bioprinting.1765325.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bioprinting.mp4
// module id = 1mN2
// module chunks = 1